import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import { SquareOff as SquareOffIcon } from './Icons';
import { SvgIcon } from '@material-ui/core';
import BorderButton from './light-weight/BorderButton';

const useStyles = makeStyles(() => ({
  root: {
    width: 50,
    minWidth: 50,
    color: '#D93A4D',
    borderColor: '#D93A4D',

    '& .action-button-svg': {
      '&--sqoff': {
        width: 20,
        height: 20,
        marginRight: 2,
        position: 'relative',
        top: 1,

        '& path': {
          fill: '#D93A4D',
        },
      },

      '&--terminate': {
        width: 20,
        height: 20,
      },
    },
  },
}));

const ActionButtonSqOff = ({ className = '', ...restProps }) => {
  const classes = useStyles();

  return (
    <BorderButton className={`${classes.root} ${className}`} {...restProps}>
      <SvgIcon
        component={SquareOffIcon}
        className="action-button-svg action-button-svg--sqoff"
      />
      <PowerSettingsNewIcon className="action-button-svg action-button-svg--terminate" />
    </BorderButton>
  );
};

export default ActionButtonSqOff;
